import { ViewModel,View } from "binder"
import  { SwitchCheckBoxView } from "./switchCheckBox-view"

export class SwitchCheckBoxViewModel extends ViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new SwitchCheckBoxView();
    }
    public getTypeId(): string {
        return "VM-A0C476C5-7D07-44E8-B823-DCC8CD695A29"
    }

    public set checkedContent(v: string) { this._checkedContent = v; } public get checkedContent(): string { return this._checkedContent;} private _checkedContent: string;
    public set uncheckedContent(v: string) { this._uncheckedContent = v; } public get uncheckedContent(): string { return this._uncheckedContent;} private _uncheckedContent: string;
    public set checked(v: boolean) { this._checked = v; } public get checked(): boolean { return this._checked;} private _checked: boolean;
    public set symmetricContent(v: boolean) { this._symmetricContent = v; } public get symmetricContent(): boolean { return this._symmetricContent;} private _symmetricContent: boolean;
    
}
